module.exports = __webpack_public_path__ + "img/thumb_chatamo.429daf01.png";